(function ($) {
    "use strict";

    $.fn.ajaxArchive = function (options) {

        // Base
        let me = this;

        // Settings
        let settings = $.extend({
            ajax_base_url: null,

            element_content: me.find('[data-content]'),
            element_pagination: me.find('[data-pages]'),
            element_search: me.find('[data-search]'),
            element_search_btn: me.find('[data-search-btn]'),
            element_reset: me.find('[data-reset]'),


            set_action: me.data('action'),
            set_per_page: me.data('per-page'),
            set_pre_filter: me.data('pre-filter'),

        }, options);

        // @toDo: Security Checks

        let Status = {
            page: 1,
            search: null,
            filter: {},
        };


        read();

        PagesSlider();

        /**
         * Detect Filters Value on Change
         * @type {*|jQuery}
         */
        let filters = me.find('[data-filter]');
        filters.each(function (index,filter){
            let key = $(filter).data('filter');
            let value = null;
            $(filter).on('change',function (){
                value = $(filter).val();
                Status.filter[key]=value;
                Status.page = 1;
                request(Status);
            });
        });


        /**
         * Request On Pressing Pagination Elements
         */
        if (settings.element_pagination.length) {
            let element_pagination = settings.element_pagination;
            element_pagination.on('click', 'li:not(.is-active) > button[data-page]', function () {
                $(this).parent().addClass('is-active').siblings().removeClass('is-active');
                // Update Request By changing New Status
                Status.page = $(this).data('page');
                request(Status,false);
            });
        }

        /**
         * Request On Searching
         */
        if (settings.element_search.length) {
            let element_search = settings.element_search;

            // Do Search On Typing
            element_search.on('keyup', setDelay(function (e) {
                do__search();
            }, 500));

            // Do Search On Clicking the Submit Button
            if (settings.element_search_btn.length) {
                let element_search_btn = settings.element_search_btn;
                element_search_btn.click(do__search);
            }
        }

        /**
         * Reset
         */
        me.on('click','[data-reset]',function (){
            // Reset Search
            if (settings.element_search.length) {
                settings.element_search.val('');
            }

            Status = {
                search: null,
                filter: {},
                page: 1
            }
            request(Status);
        });


        /**
         * Install SlickSlider for Pages
         */
        function PagesSlider(){
            if(settings.element_pagination.length){

                settings.element_pagination.find('ol').not('.slick-initialized').slick({
                    autoplay: false,
                    slidesToShow: 3,
                    slidesToScroll: 3,
                    adaptiveHeight: false,
                    arrows: true,
                    dots: false,
                    infinite: false,
                    swipe: false,
                    responsive: [
                        {
                            breakpoint: 480,
                            settings: {swipe: true, slidesToShow: 3, slidesToScroll: 3,},
                        }
                    ],
                });

            }
        }

        /**
         * Start the Search Request
         *
         */
        function do__search() {
            let element_search = settings.element_search;

            let term = element_search.val();
            if (term.length >= 3) {
                Status.search = term;
                Status.page = 1;
                request(Status);
            }

            if (term.length === 0) {
                Status.search = "";
                Status.page = 1;
                request(Status);
            }

        }

        /**
         *
         */
        function read(){
            // OnLoad detect hash.
            if(window.location.search) {
                let hash = window.location.search.substring(1);
                let paramsString = decodeURIComponent(hash);
                let _Query = Object.fromEntries(new URLSearchParams(paramsString));
                let _DoRequest = false;

                if(typeof(_Query.a_search) != "undefined" && _Query.a_search !== null) {
                    Status.search = _Query.a_search;
                    _DoRequest=true;
                }

                if(typeof(_Query.a_page) != "undefined" && _Query.a_page !== null) {
                    Status.page = _Query.a_page;
                    _DoRequest=true;
                }

                if(typeof(_Query.a_filter) != "undefined" && _Query.a_filter !== null) {

                    let filters = _Query.a_filter.split("_");
                    $(filters).each(function (i,item){
                       let filter  =  item.split(".");
                       let key = filter[0];
                        filter.shift();

                       $(filter).each(function (index,val){
                           Status.filter[key] = val;
                       });
                    });

                    _DoRequest=true;
                }

                // Stop from loading on Page Refresh
                if( _Query.a_page == 1 && Object.keys(_Query).length){
                    _DoRequest = false;
                }

                if(_DoRequest){
                    request(Status);
                }
            }
        }

        /**
         * Sends Ajax Request and Handel the Data
         *
         * @param Status
         * @param pages
         */
        function request(Status, pages = true) {

            let args = $.extend({
                action: settings.set_action,
                per_page: settings.set_per_page,
                pre_filter: settings.set_pre_filter,
                page: 1,
                filter: {},
                search: null
            }, Status);

            $.ajax({

                type: 'POST',
                url: settings.ajax_base_url,
                data: args,
                dataType: 'JSON',

                beforeSend: function () {
                    me.addClass('is-loading');
                },
                success: function (r) {

                    let _Query = cleanObject({
                        a_page: Status.page,
                        a_filter: form2URI(Status.filter),
                        a_search: Status.search,
                    });

                    settings.element_content.html(r.content);

                    if (pages === true) {
                        settings.element_pagination.html(r.pages);
                        PagesSlider();
                    }

                    window.history.replaceState({}, '', '?' + $.param(_Query,true));
                },

                complete: function () {
                    me.removeClass('is-loading');
                },

            });


        }

        /**
         * Converts Form Inputs into a Small URI
         *
         * @param form
         * @returns {string|*|string}
         */
        function form2URI(form) {

            if (typeof (form) == "undefined" || form == null) {
                return '';
            }

            let _SEP_ID = '.';
            let _SEP_GROUP = '_';

            let _URI = '';
            let _Group = [];


            for (let key in form) {
                _Group.push(key + _SEP_ID + form[key]);
            }

             /* $.each(form, function (key, item) {
                 //form[key] = key + _SEP_ID + item.join(_SEP_ID);
             });*/


            /*form = $.map(form, function (value, index) {
                 return [value];
             });*/

            _URI = _Group.join(_SEP_GROUP);
            return _URI;
        }

        /**
         * Add Delay between Repetitive Events
         *
         * @param callback
         * @param ms
         * @returns {(function(): void)|*}
         */
        function setDelay(callback, ms) {
            var timer = 0;
            return function () {
                var context = this, args = arguments;
                clearTimeout(timer);
                timer = setTimeout(function () {
                    callback.apply(context, args);
                }, ms || 0);
            };
        }

        /**
         * Remove Empty Elements in Objects
         *
         * @param obj
         * @returns {*}
         */
        function cleanObject(obj) {
            for (var propName in obj) {
                if (obj[propName] === null || obj[propName] === undefined || obj[propName] === "") {
                    delete obj[propName];
                }
            }
            return obj
        }



        return me;

    };


}(jQuery));
